<template>
    <div>
        <div class="border-thin rounded-lg p-3 pb-2 mb-3">
            <your-vehicle
                v-if="registration != null"
                :registration="registration"
                :make="make"
                :model="model"
                :postcode="postcode"
                :size-options="sizeOptions"
            ></your-vehicle>
            <fitter-filters
                :filters="filters"
                :has-reviews="hasReviews"
                :page="page"
                :postcode="filters.postcode"
                :fitters-shown="fittersShown"
                @update-filters="updateFilters"
                @submit="getFitters"
            ></fitter-filters>
        </div>
        <div class="row mb-3">
            <div id="fitters-column" class="col-12 col-lg-5 fitters-column" :style="fittersHeight">
                <template v-if="hasSearched && (postcode || filters.postcode) && (!updatedSortedFitters || updatedSortedFitters.length === 0)">
                    <template v-if="mobileFittingRoute">
                        <p class="mb-0">There are no mobile fitters available within your area.</p>
                        <p class="mb-0">Please use the button below to search for garages.</p>
                        <button
                            @click="loadGarageFitters()"
                            type="button"
                            class="btn btn-primary mt-2"
                        >Search for Garage Fitters</button>
                    </template>
                    <template v-else>
                        <p>There are no fitters available within your area.</p>
                        <p>Please use the filters above to change your search, or use the button below to increase your search radius.</p>
                        <button type="button" class="btn btn-primary" @click="manuallyIncreaseSearchRadius()">Increase search distance</button>
                    </template>
                </template>
                <div class="row">
                    <fitter
                        v-for="fitter in updatedSortedFitters"
                        :fitter="fitter"
                        :key="fitter.id"
                        :route="route"
                        :mobile-fitting-slots="mobileFittingSlots"
                        :view="view"
                        v-bind:ref="el => setFitterRef(el, fitter.id)"
                    ></fitter>
                </div>
				<div class="text-center col-12" v-if="canLoadMoreFitters">
					<button class="fitter-page-load-more btn btn-primary" type="button" @click="loadMoreFitters()">
						Load 10 more fitters
					</button>
				</div>
            </div>
            <div class="col-12 col-sm-7 d-none d-lg-block">
                <fitter-map
                    v-if="updatedSortedFitters && updatedSortedFitters.length > 0"
                    :fitters="updatedSortedFitters"
                    :google-maps-api-key="googleMapsApiKey"
                    :postcode-details="updatedPostcodeDetails"
                    :view="view"
                ></fitter-map>
            </div>
        </div>
    </div>
</template>

<script>
    import helpers from '@shared/mixins/helpers';
    import fitters from '@shared/mixins/fitters';

    export default {
        props: [
            'sortedFitters',
            'distance',
            'sortBy',
            'fitterTypes',
            'limit',
            'page',
            'postcode',
            'fitters',
            'mobileFitters',
            'chooseFitterFilters',
            'fitterResultsLimit',
            'hasReviews',
            'googleMapsApiKey',
            'postcodeDetails',
            'route',
            'mobileFittingSlots',
            'view',
            'mobileFittingRoute',
            'mountedSearch',
            'imageBaseUrl',
            'registration',
            'make',
            'model',
            'sizeOptions'
        ],
        mixins: [helpers, fitters],
        data() {
            return {
                // store component refs by fitter id to avoid using dynamic string refs
                fitterRefs: {}
            };
        },
        mounted() {
            //removes loading placeholder - fixes CLS issue
            document.querySelector('#loadingPlaceholder').style.display = 'none';
        },
        methods:{
            setFitterRef(el, id) {
                // ref callback: store or remove element by id
                if (el) {
                    this.fitterRefs[id] = el;
                } else {
                    delete this.fitterRefs[id];
                }
            }
        },
        computed: {
            canLoadMoreFitters() {
                if (!this.updatedSortedFitters || this.updatedSortedFitters.length === 0) return false;

                const result = this.updatedSortedFitters.length % this.filters.limit;

                if (result !== 0) {
                    return false;
                }

                return true;
            },
            fittersHeight() {
                return (this.updatedSortedFitters && this.updatedSortedFitters.length > 0) ? 'height: 80vh' : '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fitters-column {
        @media screen and (max-width: 991px) {
            height: auto !important;
        }
        @media screen and (min-width: 992px) {
            overflow-x: scroll;
        }
    }
</style>